import {getEmbedLink} from './video-popup-helper';

type PropsType = {
    url: string;
};

export function VideoPlayer(props: PropsType): JSX.Element {
    const {url} = props;

    const videoLink = getEmbedLink(url) || url;

    return (
        // eslint-disable-next-line react/iframe-missing-sandbox
        <iframe
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
            frameBorder="0"
            height="100%"
            src={videoLink}
            title="Video player"
            width="100%"
        />
    );
}
